import { useMemo } from 'react';
import { Action, EventType, ObjectType } from 'api/pushes';
import { useIsTaskPaneOptimizationEnabled } from 'hooks/use-feature';
import { useProjectWSUpdates } from 'hooks/use-project-ws-updates';
import { useTaskDetailQuery, useTaskDetailsDefaultFieldsQuery, useTaskPaneUpdate } from 'queries/task';
/**
 *
 * @deprecated Use `TasksStore.ofId`. Additional information like attachments
 * should come from other stores.
 *
 *
 * only write the partucular task's specific functionality here
 * anything else go write somewhere else
 * dont come here
 */ export const useTaskDetailStore = (taskId)=>{
    const [, projectId, tId] = taskId;
    const isTaskPaneOptimzationEnabled = useIsTaskPaneOptimizationEnabled();
    const { data: taskDetailData, isLoading: isTaskDetailLoading, ...restOfTheTaskDetailData } = useTaskDetailQuery(taskId, {
        // keepPreviousData: true,
        refetchOnMount: true,
        enabled: !isTaskPaneOptimzationEnabled
    });
    const { data: taskDefaultFields, isLoading: isTaskDefaultFieldsLoading, ...restOfTheTaskDetailFields } = useTaskDetailsDefaultFieldsQuery({
        projectId,
        taskId: tId
    }, {
        refetchOnMount: true,
        enabled: isTaskPaneOptimzationEnabled
    });
    const { handleTaskSocketUpdate } = useTaskPaneUpdate(taskId);
    const data = isTaskPaneOptimzationEnabled ? taskDefaultFields : taskDetailData;
    const isLoading = isTaskPaneOptimzationEnabled ? isTaskDefaultFieldsLoading : isTaskDetailLoading;
    const rest = isTaskPaneOptimzationEnabled ? restOfTheTaskDetailFields : restOfTheTaskDetailData;
    useProjectWSUpdates(projectId, handleTaskSocketUpdate, EventType(Action.Update, ObjectType.Task));
    const query = useMemo(()=>{
        var _data_project, _data_subTasks;
        return {
            data: data ? {
                ...data,
                project: data === null || data === void 0 ? void 0 : (_data_project = data.project) === null || _data_project === void 0 ? void 0 : _data_project.projectId,
                subTasks: data === null || data === void 0 ? void 0 : (_data_subTasks = data.subTasks) === null || _data_subTasks === void 0 ? void 0 : _data_subTasks.map((e)=>e === null || e === void 0 ? void 0 : e.taskId)
            } : data,
            isLoading,
            ...rest
        };
    }, [
        data,
        isLoading,
        rest
    ]);
    return query;
};
